'use client';

import { createContext, useContext, type ReactNode } from 'react';

/**
 * React context that carries the active tenant IANA timezone for any
 * descendant consumer calling `useTenantTimezone()`, so callers don't have
 * to thread a `timezone` prop through dozens of component layers.
 *
 * Mounted in the team-account layout from `business_settings.time_zone`.
 * Descendant components call `useTenantTimezone()` to format timestamps in
 * the tenant's timezone instead of the browser's.
 */
export const TenantTimezoneContext = createContext<string>('Asia/Riyadh');

export function TenantTimezoneProvider({
  value,
  children,
}: {
  value: string;
  children: ReactNode;
}) {
  return (
    <TenantTimezoneContext.Provider value={value || 'Asia/Riyadh'}>
      {children}
    </TenantTimezoneContext.Provider>
  );
}

/** Read the active tenant IANA timezone from the nearest provider. */
export function useTenantTimezone(): string {
  return useContext(TenantTimezoneContext);
}
